export const CALL_STATUS = {
  in_progress: { label: "In Progress", badge: "bg-sky-50 text-sky-700" },
  completed: { label: "Completed", badge: "bg-emerald-50 text-emerald-700" },
  transferred: { label: "Transferred", badge: "bg-amber-50 text-amber-700" },
  missed: { label: "Missed", badge: "bg-slate-100 text-slate-500" },
  failed: { label: "Failed", badge: "bg-red-50 text-red-600" },
};

export const SENTIMENT = {
  positive: { label: "Positive", badge: "bg-emerald-50 text-emerald-700" },
  neutral: { label: "Neutral", badge: "bg-slate-100 text-slate-600" },
  negative: { label: "Negative", badge: "bg-red-50 text-red-600" },
};

export const callStatusMeta = (s) => CALL_STATUS[s] || CALL_STATUS.completed;
export const sentimentMeta = (s) => SENTIMENT[s] || SENTIMENT.neutral;

export function fmtDuration(sec) {
  if (!sec || sec < 0) return "—";
  const m = Math.floor(sec / 60);
  const s = sec % 60;
  return m ? `${m}m ${s}s` : `${s}s`;
}
